import angular from 'angular';
import 'angular-ui-mask';
import { FocusingHelper } from './focusing';

export default angular.module('app.helpers', ['ui.mask', FocusingHelper.name]);
